import { FeedbackActionTypes } from './enums';
import { type FeedbackAction, type IFeedbackState } from './interfaces';

export const initialState: IFeedbackState = {
	// Create
	isCreatingFeedback: false,
	createFeedbackResponse: null,
	createFeedbackError: null,

	// Fetch All
	isFetchingAllFeedback: false,
	fetchAllFeedbackResponse: null,
	fetchAllFeedbackError: null,

	// Get By ID
	isFetchingFeedbackById: false,
	feedbackDetail: null,
	getFeedbackByIdError: null,

	// Resolve
	isResolvingFeedback: false,
	resolveFeedbackError: null
};

export default (state = initialState, { type, payload }: FeedbackAction): IFeedbackState => {
	switch (type) {
		// ─── Create Feedback ──────────────────────────────────────────────
		case FeedbackActionTypes.CREATE_FEEDBACK_REQUEST:
			return {
				...state,
				isCreatingFeedback: true,
				createFeedbackResponse: null,
				createFeedbackError: null
			};
		case FeedbackActionTypes.CREATE_FEEDBACK_SUCCESS:
			return {
				...state,
				isCreatingFeedback: false,
				createFeedbackResponse: payload
			};
		case FeedbackActionTypes.CREATE_FEEDBACK_FAILURE:
			return {
				...state,
				isCreatingFeedback: false,
				createFeedbackError: payload
			};

		// ─── Fetch All Feedback ───────────────────────────────────────────
		case FeedbackActionTypes.FETCH_ALL_FEEDBACK_REQUEST:
			return {
				...state,
				isFetchingAllFeedback: true,
				fetchAllFeedbackResponse: null,
				fetchAllFeedbackError: null
			};
		case FeedbackActionTypes.FETCH_ALL_FEEDBACK_SUCCESS:
			return {
				...state,
				isFetchingAllFeedback: false,
				fetchAllFeedbackResponse: payload
			};
		case FeedbackActionTypes.FETCH_ALL_FEEDBACK_FAILURE:
			return {
				...state,
				isFetchingAllFeedback: false,
				fetchAllFeedbackError: payload
			};

		// ─── Get Feedback By ID ───────────────────────────────────────────
		case FeedbackActionTypes.GET_FEEDBACK_BY_ID_REQUEST:
			return {
				...state,
				isFetchingFeedbackById: true,
				feedbackDetail: null,
				getFeedbackByIdError: null
			};
		case FeedbackActionTypes.GET_FEEDBACK_BY_ID_SUCCESS:
			return {
				...state,
				isFetchingFeedbackById: false,
				feedbackDetail: payload
			};
		case FeedbackActionTypes.GET_FEEDBACK_BY_ID_FAILURE:
			return {
				...state,
				isFetchingFeedbackById: false,
				getFeedbackByIdError: payload
			};

		// ─── Resolve Feedback ─────────────────────────────────────────────
		case FeedbackActionTypes.RESOLVE_FEEDBACK_REQUEST:
			return {
				...state,
				isResolvingFeedback: true,
				resolveFeedbackError: null
			};
		case FeedbackActionTypes.RESOLVE_FEEDBACK_SUCCESS:
			return {
				...state,
				isResolvingFeedback: false,
				feedbackDetail: state.feedbackDetail
					? { ...state.feedbackDetail, isResolved: true }
					: null
			};
		case FeedbackActionTypes.RESOLVE_FEEDBACK_FAILURE:
			return {
				...state,
				isResolvingFeedback: false,
				resolveFeedbackError: payload
			};

		// ─── Reset ────────────────────────────────────────────────────────
		case FeedbackActionTypes.RESET_FEEDBACK_STATE:
			return initialState;

		default:
			return state;
	}
};
